import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const ItemPowerReport = ({ report, selectItem }) => {
    const [data, setData] = useState();

    useEffect(() => {
        setData(report);
    }, [report]);

    if (data === undefined) {
        return (<h4>Loading...</h4>);
    }

    return (
        <Row>
            <Col xl={4}>
                <p onClick={()=>selectItem(data)}>{report.item_name}</p>
            </Col>
            <Col>
                <p>{report.item_owner}</p>
            </Col>
            <Col>
                <p>{report.item_location}</p>
            </Col>
            <Col>
                <p>{report.item_power}</p>
            </Col>
        </Row>
    );
}

export default ItemPowerReport;